import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

// Gets if Inbox Plus feature is enabled for the user
export default function isInboxPlusEnabled(): boolean {
    return (
        isFeatureEnabled('tri-inbox-plus-v1') &&
        getUserConfiguration().UserOptions.InboxPlusTabs !== null
    );
}
